import { z } from 'zod';
import { ExternalContactSchema } from '../../entities/external-contact/external-contact.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * Show External Contact Request Schema
 * GET /api/v2/external-contacts/:id
 */ export const ShowExternalContactRequestSchema = IncludeDeletedRequestSchema;
/**
 * Show External Contact Response Schema
 * GET /api/v2/external-contacts/:id
 */ export const ShowExternalContactResponseSchema = z.object({
    data: ExternalContactSchema
});

//# sourceMappingURL=show-external-contact.schema.js.map